export default __webpack_public_path__ + "static/media/social-linkedin.fefa1be0.svg";